import { TYPES } from "./types";
import { tkt1TrustedBankAccountService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1TrustedBankAccounts = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankAccountService.getTrustedBankAccounts(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedBankAccountByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankAccountService.getTrustedBankAccountByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedBankAccountByMID = (mid) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankAccountService.getTrustedBankAccountByMID(mid);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_BANK_ACCOUNT_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1TrustedBankAccounts = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankAccountService.searchTrustedBankAccounts(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_TRUSTED_BANK_ACCOUNTS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1TrustedBankAccount = (accountData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankAccountService.createTrustedBankAccount(accountData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1TrustedBankAccount = (id, accountData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankAccountService.updateTrustedBankAccount(id, accountData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1TrustedBankAccount = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedBankAccountService.deleteTrustedBankAccount(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_BANK_ACCOUNT_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1TrustedBankAccountAction = {
  getTKT1TrustedBankAccounts,
  getTKT1TrustedBankAccountByID,
  getTKT1TrustedBankAccountByMID,
  searchTKT1TrustedBankAccounts,
  createTKT1TrustedBankAccount,
  updateTKT1TrustedBankAccount,
  deleteTKT1TrustedBankAccount
};
